// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"4515902b","142":"484969d0","368":"704538ce","414":"f9d7779b","557":"4f53fe43","656":"6179e2e5","803":"5191e559","902":"b2bed037","939":"062408a3","965":"c4352253"}[chunkId] + ".chunk.js";
};